var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", [
        _c("footer", { staticClass: "py-4 bg-cyan" }, [
          !_vm.routeBlacklist()
            ? _c("div", [
                _c("div", {
                  staticClass: "text-center",
                  domProps: {
                    innerHTML: _vm._s(_vm.data.bottom.bottomLoginText)
                  }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "text-center" }, [
                  _c("button", {
                    staticClass: "btn btn-share btn-dark btn-sm",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.startpage.loginResultsBtnText)
                    },
                    on: {
                      click: function($event) {
                        return _vm.$router.push("/login-tr")
                      }
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.name === "testresult"
            ? _c("div", [
                _c("p", { staticClass: "text-center" }, [
                  _c("button", {
                    staticClass: "btn btn-share btn-dark btn-sm",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.startpage.logoutResultsBtnText)
                    },
                    on: {
                      click: function($event) {
                        return _vm.logOut()
                      }
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix--min" }),
          _vm._v(" "),
          _c("div", {
            staticClass: "text-center",
            domProps: { innerHTML: _vm._s(_vm.data.bottom.bottomText) }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "text-center" }, [
            _c("button", {
              staticClass: "btn btn-share btn-info btn-sm",
              domProps: { innerHTML: _vm._s(_vm.data.bottom.shareBtnText) },
              on: {
                click: function($event) {
                  return _vm.shareCheckMe()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "text-center",
            domProps: { innerHTML: _vm._s(_vm.data.bottom.copyrightText) }
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "img-footer",
            attrs: {
              src: require("../assets/img/karolinska.svg"),
              alt: "Logotyp för Karolinska"
            }
          })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0959a4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0959a4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bottom.vue
// module id = null
// module chunks = 